/**
 * Create a DOM node.
 *
 * @param tag
 *   The HTML tag name of the DOM node to create, or a function that returns a DOM node.
 * @param props
 *   Properties to assign to the DOM node or props to pass to the tag function.
 * @returns
 *   The created DOM node.
 */
export const jsx = (tag, { children, ref, ...props } = {}) => {
    const node = document.createElement(tag);
    const appendChildren = (child) => {
        if (Array.isArray(child)) {
            child.forEach(appendChildren);
        }
        else if (child != null && child !== true && child !== false) {
            node.append(child);
        }
    };
    Object.entries(props).forEach(([key, value]) => {
        if (key in node) {
            if (node[key] instanceof Object && value instanceof Object) {
                Object.assign(node[key], value);
            }
            else {
                node[key] = value;
            }
        }
        else {
            node.setAttribute(key, value);
        }
    });
    appendChildren(children);
    ref?.(node);
    return node;
};
/**
 * This is needed for the JSX automatic runtime interface.
 *
 * @internal
 */
export const Fragment = undefined;
export { jsx as jsxs, jsx as jsxDEV };
